'use client';

import { useBalloonPops, BALLOON_FILL, BALLOON_STROKE } from './useBalloonPops';
import styles from './BalloonPops.module.scss';
import { Box } from '@mui/material';

export const BalloonPops = ( { looping = false } ) => {
	const {
		containerRef,
		canvasRef,
		visible,
		scale,
		stageWidth,
		stageHeight,
		balloonX,
		balloonY,
		knotX,
		knotY,
		stringEndY,
		sway,
	} = useBalloonPops( looping );

	return (
		<Box className={ styles.animationBase } ref={ containerRef }>
			<Box
				className={ styles.stage }
				style={ {
					width: stageWidth,
					height: stageHeight,
					transform: `translate(-50%, -50%) scale(${ scale })`,
				} }
			>
				{ visible ? (
					<svg
						width={ stageWidth }
						height={ stageHeight }
						style={ {
							position: 'absolute',
							top: 0,
							left: 0,
							overflow: 'visible',
						} }
					>
						<path
							d={ `M ${ knotX } ${ knotY } C ${ knotX + sway + 24 } ${ knotY + 52 }, ${
								knotX - sway - 18
							} ${ knotY + 108 }, ${ knotX + sway * 0.4 } ${ stringEndY }` }
							stroke={ BALLOON_STROKE }
							strokeWidth='2'
							fill='none'
							strokeLinecap='round'
						/>

						<g transform={ `translate(${ balloonX }, ${ balloonY })` }>
							<ellipse
								cx='0'
								cy='-6'
								rx='62'
								ry='68'
								fill={ BALLOON_FILL }
								stroke={ BALLOON_STROKE }
								strokeWidth='2'
							/>
							<path
								d='M -10,60 Q 0,72 10,60'
								fill={ BALLOON_FILL }
								stroke={ BALLOON_STROKE }
								strokeWidth='2'
								strokeLinejoin='round'
								strokeLinecap='round'
							/>
							<path
								d='M 10,-52 Q 32,-44 30,-22'
								fill='none'
								stroke='rgba(255,255,255,0.85)'
								strokeWidth='6'
								strokeLinecap='round'
							/>
							<circle
								cx='0'
								cy='72'
								r='5'
								fill={ BALLOON_FILL }
								stroke={ BALLOON_STROKE }
								strokeWidth='2'
							/>
						</g>
					</svg>
				) : null }

				<canvas
					ref={ canvasRef }
					width={ stageWidth }
					height={ stageHeight }
					style={ { position: 'absolute', top: 0, left: 0 } }
				/>
			</Box>
		</Box>
	);
};
